import type { ConnectorDefinition } from "../types";
import { concurConnector } from "./concur-user";
import { cxalloyConnector } from "./cxalloy";
import { databricksConnector } from "./databricks";
import { egnyteConnector } from "./egnyte";
import { freshserviceAgentConnector } from "./freshservice-agent";
import { freshserviceRequesterConnector } from "./freshservice-requester";
import { githubConnector } from "./github";
import { knowledgeEngineConnector } from "./knowledge-engine";
import { microsoftConnector } from "./microsoft";
import { mondayConnector } from "./monday";
import { notionConnector } from "./notion";
import { procoreConnector } from "./procore";
import { quickbaseConnector } from "./quickbase";
import { slackConnector } from "./slack";
import { smartsheetConnector } from "./smartsheet";

export const connectorDefinitions: ConnectorDefinition[] = [
  concurConnector,
  databricksConnector,
  knowledgeEngineConnector,
  microsoftConnector,
  procoreConnector,
  quickbaseConnector,
  slackConnector,
  smartsheetConnector,
  mondayConnector,
  githubConnector,
  egnyteConnector,
  notionConnector,
  freshserviceAgentConnector,
  freshserviceRequesterConnector,
  cxalloyConnector,
];

export const connectorDefinitionsById: Record<string, ConnectorDefinition> =
  Object.fromEntries(connectorDefinitions.map((d) => [d.id, d]));

export function getConnectorDefinition(
  connectorType: string
): ConnectorDefinition | undefined {
  return connectorDefinitionsById[connectorType];
}

export function getEnabledConnectorDefinitions(): ConnectorDefinition[] {
  return connectorDefinitions.filter((d) => d.isEnabled?.() ?? true);
}

export function getConnectorDefinitionsByAuthType(
  authType: ConnectorDefinition["authType"]
): ConnectorDefinition[] {
  return connectorDefinitions.filter((d) => d.authType === authType);
}

export { concurConnector } from "./concur-user";
export {
  CXALLOY_CLOCK_SKEW_MESSAGE,
  CXALLOY_USER_AGENT,
  cxalloyApiBase,
  cxalloyConnector,
  cxalloyHeaders,
  isCxalloyAuthError,
  isCxalloyClockSkewError,
  signCxalloyRequest,
} from "./cxalloy";
export { databricksConnector } from "./databricks";
export { egnyteApiBase, egnyteConnector, egnyteDomain } from "./egnyte";
export {
  freshserviceAgentConnector,
  freshserviceBaseUrl,
  freshserviceDefaultGroupId,
  freshserviceDomain,
} from "./freshservice-agent";
export {
  freshserviceRequesterApiKey,
  freshserviceRequesterConnector,
} from "./freshservice-requester";
export {
  GITHUB_READ_TOOLS,
  GITHUB_WRITE_TOOLS,
  githubConnector,
} from "./github";
export { knowledgeEngineConnector } from "./knowledge-engine";
export { microsoftConnector } from "./microsoft";
export {
  MONDAY_EXCLUDED_TOOLS,
  MONDAY_READ_TOOLS,
  MONDAY_WRITE_TOOLS,
  mondayConnector,
} from "./monday";
export {
  NOTION_READ_TOOLS,
  NOTION_WRITE_TOOLS,
  notionConnector,
} from "./notion";
export { procoreConnector } from "./procore";
export {
  QUICKBASE_API_BASE,
  quickbaseConnector,
  quickbaseRealmHostname,
} from "./quickbase";
export { slackConnector } from "./slack";
export {
  SMARTSHEET_EXCLUDED_TOOLS,
  SMARTSHEET_READ_TOOLS,
  SMARTSHEET_WRITE_TOOLS,
  smartsheetConnector,
} from "./smartsheet";
